

type LoaderActionComponentProps = {
    onLoad: () => void;
}

export default function LoaderActionComponent({onLoad}: LoaderActionComponentProps) {
      return (
        <div className="loader" onLoad={() => onLoad()}>  
            <div className="p-md bg-blanc">        
                <div className="p-md ta-center">            
                <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/loader.gif"} width="80" height="80" style={{boxShadow: "none"}} />   
                <div className="p-md">Traitement en cours, merci de patienter...</div> 
                </div>    
            </div>
        </div>
    )
}